import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@figure/frontlib-gui';
import { numericFormatter } from '@figure/frontlib-util';
import { reduxPropTypes } from '@figure/frontlib-onboarding-redux';

const Container = styled.div`
  margin-top: 30px;
`;

const LinkSubmit = ({ offerPackage, handleSubmit }) => {
  let text = '';
  if (offerPackage.subDecision === 'VERIFIED_INCOME_MATCHED_OFFER') {
    text = 'Save and continue';
  } else if (offerPackage.max > 0 && offerPackage.verifiedTotalIncome > 0 && offerPackage.subDecision !== 'UNVERIFIED_OFFER') {
    text = `Borrow up to ${numericFormatter.formatMoney(Math.floor(offerPackage.max))}`;
  }

  return !text ? null : (
    <Container>
      <Button primary center onClick={handleSubmit} data-test-id="save-and-continue">
        {text}
      </Button>
    </Container>
  );
};

LinkSubmit.propTypes = {
  offerPackage: reduxPropTypes.offerPackage.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default LinkSubmit;
